<section *ngIf="!loading" id="settings" class="content">
    <div [class.form-group]="!(firstName.dirty && !firstName.valid)">
        <label class="font-weight-bold">{{ 'first_name' | localise }}</label>
        <input
                type="text"
                class="form-control"
                [placeholder]="'enter_first_name' | localise"
                [formControl]="firstName"
                [inputValidation]="{
        condition: firstName.dirty && !firstName.valid,
        error: 'enter_first_name' | localise
      }"
        />
    </div>
    <div [class.form-group]="!(surname.dirty && !surname.valid)">
        <label class="font-weight-bold">{{ 'surname' | localise }}</label>
        <input
                type="text"
                class="form-control"
                [placeholder]="'enter_surname' | localise"
                [formControl]="surname"
                [inputValidation]="{
        condition: surname.dirty && !surname.valid,
        error: 'enter_surname' | localise
      }"
        />
    </div>
    <div [class.form-group]="!(phone.dirty && !phone.valid)">
        <label class="font-weight-bold">{{ 'phone' | localise }}</label>

        <div class="clear"></div>

        <span (click)="openDialCodeModal()" class="dial_code">
            {{ selectedPhoneDialCode }}
            <i class="fa fa-caret-down"></i>
        </span>

        <input
                type="text"
                class="form-control phone_number"
                pattern="[0-9]+"
                [placeholder]="'enter_phone' | localise"
                [formControl]="phone"
                [inputValidation]="{
        condition: phone.dirty && !phone.valid,
        error: 'enter_phone' | localise
      }"
        />

        <div class="clear"></div>
    </div>
    <div class="form-group">
        <label class="font-weight-bold" id="gender">{{ 'gender' | localise }}</label>
        <div class="form-check">
            <label class="form-check-label">
                <input type="radio" class="form-check-input" name="gender" id="genderM" value="M"
                       (input)="onGenderSelected('M')"
                       [checked]="currentlySelectedGender?.gender === 'M'"/>
                {{ 'male' | localise }}
                <i class="input-helper"></i>
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input type="radio" class="form-check-input" name="gender" value="F" id="genderF"
                       (input)="onGenderSelected('F')"
                       [checked]="currentlySelectedGender?.gender === 'F'"/>
                {{ 'female' | localise }}
                <i class="input-helper"></i>
            </label>
        </div>
    </div>
    <div class="mt-4" *ngIf="editable">
        <button class="btn btn-block btn-primary" (click)="updateProfile()"
                [disabled]="saveButtonIsDisabled">{{ 'save' | localise }}</button>
    </div>
</section>
<ng-container *ngIf="loading">
    <app-loading></app-loading>
</ng-container>
